import { useCallback } from 'react';
import Text from '@ui/text/text/text';
import SettingsToggle from '../../controls/settings-toggle';
import { useAppDispatch, useAppSelector } from '@/store/hooks';
import { selectIsDrmRequired, selectIsSavingWorkingProject } from '@/store/slices/project/selectors';
import { setStreamingOptionOnAllSessions } from '@/store/slices/project';
import WatermarkWidget from './watermark/watermark-widget';

const ContentSecurity = () => {
  const isSaving = useAppSelector(selectIsSavingWorkingProject);
  const useDrm = useAppSelector(selectIsDrmRequired);

  const dispatch = useAppDispatch();

  const handleDrmToggle = useCallback(
    (_: string, on: boolean) => {
      dispatch(
        setStreamingOptionOnAllSessions({
          drm_required: on,
        })
      );
    },
    [dispatch]
  );

  return (
    <div className="flex-column gap-8">
      <Text className="H5" design="GlobalIcoText1">
        Content Security
      </Text>
      <WatermarkWidget />
      <SettingsToggle
        label="Digital Rights Management"
        value={!!useDrm}
        sKey="drm"
        disabled={isSaving}
        loading={isSaving}
        onToggle={handleDrmToggle}
      />
    </div>
  );
};

export default ContentSecurity;
